module.exports = __webpack_public_path__ + "components/carousel-resort-picks/static/generic-bg--4-4254349cebafcbf98124708392046ace.jpg";